import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

const campanasAdapter = createEntityAdapter({
  selectId: x => x.campanaId,
})

const initialState = campanasAdapter.getInitialState();

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getCampanas: builder.query({
      query: () => 'campanas',
      transformResponse: responseData => {
        return campanasAdapter.setAll(initialState, responseData)
      },
      providesTags: (result, error, arg) => [
        { type: 'Campanas', id: 'LIST' }
      ]
    }),
    getTiposCampana: builder.query({
      query: () => 'tipos-campana',
      providesTags: (result, error, arg) => [
        { type: 'TiposCampana', id: 'LIST' }
      ]
    }),
  })
});

export const { useGetCampanasQuery, useGetTiposCampanaQuery } = extendedApiSlice;

//A: returns the query result object
export const selectCampanasResut = extendedApiSlice.endpoints.getCampanas.select();

//A: created memoized selector
const selectCampanasData = createSelector(
  selectCampanasResut,
  campanasResult => campanasResult.data  //A: normalized state object with ids and entities
);


//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  selectAll: selectAllCampanas,
  selectById: selectCampanasById,
  selectIds: selectCampanasIds
} = campanasAdapter.getSelectors(state => selectCampanasData(state) ?? initialState);